import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import Container from "components/layout/Container";
import CameraTable from "components/camera/CameraTable";
import { UserPolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Camera: React.FC = () => {
  const { t } = useTranslation("camera");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle" component="h1">
            {t("title")}
          </HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <CameraTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const CameraAuth: React.FC = () => {
  const { hasSystemTypeNamePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasSystemTypeNamePolicy("camera", UserPolicyTypes.enable);
  }, [hasSystemTypeNamePolicy]);
  return (
    <>
      {hasRight ? (
        <Container noHVContainer>
          {" "}
          <Camera />
        </Container>
      ) : (
        <NotFound />
      )}
    </>
  );
};
export default Camera;
